export enum ShipmentState {
  DRAFT = 'DRAFT',
  SENDING = 'SENDING',
  SENT = 'SENT',
  CANCELLED = 'CANCELLED',
  SENDING_FAILED = 'SENDING_FAILED',
  FAILED = 'FAILED',
  COMPLETED = 'COMPLETED',
}
